import React, { Component } from 'react';
import { MyContext, MyHeading, MyGlobal } from '../components/GlobalContext';
import { MenuComponent } from './MenuComponent';

export class MainMenu extends Component {
    static displayName = MainMenu.name;

    constructor(props) {
        super(props);
        this.history = props.history;
    }

    componentDidMount() {
    }

    render() {
        const data = [
            {
                menuName: 'Enquiries',
                path: 'enquiries/Enquiry'
            },
            //{
            //    menuName: 'Client Apps',
            //    path: 'ClientApps'
            //},
            {
                menuName: 'Inwards',
                path: 'Inwards'
            },
            {
                menuName: 'Paperless Picking',
                path: 'paperlesspicking/ChoosePick'
            },
            {
                menuName: 'SCS Stocktake',
                path: 'Stocktake/SelectStocktake'
            },
            //{
            //    menuName: 'Outwards',
            //    path: 'Outwards'
            //},
            {
                menuName: 'Transfers',
                path: 'transfers/Transfer'
            },
            {
                menuName: 'Freight',
                path: 'freight/Freight'
            },
            //{
            //    menuName: 'Supervisor Menu',
            //    path: 'SupervisorMenu'
            //},
            {
                menuName: 'Print Settings',
                path: 'printSettings/PrintSettings'
            },
            {
                menuName: 'Change Warehouse',
                path: 'Warehouse'
            },
            {
                menuName: 'Log Off',
                path: 'LogOff'
            }
        ];
        return (
            <div>
                <MenuComponent menuData={data} history= {this.history} />
            </div>

        );
    }

}
